export const loadRewardfulScript = () => {
    if (!!(window as any).Rewardful) {
        return;
    }

    var scriptTag = document.createElement('script');

    scriptTag.src = 'https://r.wdfl.co/rw.js';
    scriptTag.async = true;
    scriptTag.setAttribute('data-rewardful', 'fcc976');
    scriptTag.setAttribute('data-domains', 'pricewell.com, pricewell.io');
    document.getElementsByTagName('head')[0].appendChild(scriptTag);
};
